import _pt from "prop-types";
import React from 'react';
import Element from './Element';
import Parser from './Parser';
export default function Markup(props) {
  var content = props.content,
      emptyContent = props.emptyContent,
      parsedContent = props.parsedContent,
      tagName = props.tagName;
  var tag = tagName || 'div';
  var mainContent;

  if (parsedContent) {
    mainContent = parsedContent;
  } else {
    var markup = new Parser(content || '', props).parse();

    if (markup.length > 0) {
      mainContent = markup;
    }
  }

  if (!mainContent) {
    mainContent = emptyContent;
  }

  if (tag === 'fragment') {
    return React.createElement(React.Fragment, null, mainContent);
  }

  return React.createElement(Element, {
    tagName: tag
  }, mainContent);
}
Markup.propTypes = {
  content: _pt.oneOfType([_pt.string, _pt.oneOf([null])]),
  emptyContent: _pt.node,
  parsedContent: _pt.node,
  tagName: _pt.oneOfType([_pt.oneOf(['fragment']), _pt.string])
};